import { FavoriteLocations } from '@/components/account/favorites/favoriteLocations';
import FavoriteOrders from '@/components/account/favorites/favoriteOrders';
import Layout from '@/components/app/layout/index';
import { RestrictedAccountRoute } from '@/components/restrict';

export default function FavoritesPage() {
  return (
    <RestrictedAccountRoute>
      <Layout $backgroundOverride={true}>
        <FavoriteOrders />
        <FavoriteLocations />
      </Layout>
    </RestrictedAccountRoute>
  );
}
